import responseHandler from "../system/server-response-handler";
import { getRequest, postRequest, putRequest } from "../system/server-calls";

const getUserProfile = (id) => {
  return getRequest(`User/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};
const updateUserProfile = (data) => {
  return putRequest("User", data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const sendFeedback = (data) => {
  return postRequest("User/SendFeedback", data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const userService = {
  sendFeedback,
  getUserProfile,
  updateUserProfile,
};
